/**
 * คำนวณอายุ (ปีเต็ม) จากวันเกิด
 * @param dateOfBirth - ISO date string (YYYY-MM-DD)
 */
export function computeAge(dateOfBirth: string): number {
  const birth = new Date(dateOfBirth);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
}

/**
 * คำนวณ Generation จากปีเกิด
 * อิงตามนิยามสากล (ปรับตามบริบทลาว/เอเชียตะวันออกเฉียงใต้)
 */
export function computeGeneration(dateOfBirth: string): string {
  const year = new Date(dateOfBirth).getFullYear();
  if (year >= 2013) return "Gen Alpha";
  if (year >= 1997) return "Gen Z";
  if (year >= 1981) return "Millennial";
  if (year >= 1965) return "Gen X";
  if (year >= 1946) return "Boomer";
  return "Silent";
}

/**
 * คำนวณจำนวนวันที่เหลือถึงวันที่กำหนด
 * คืนค่าลบถ้าเลยกำหนดไปแล้ว
 */
export function daysUntil(targetDate: string): number {
  const target = new Date(targetDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}
